import React from "react";
import PropTypes from "prop-types";
import styles from "./Body.module.scss";
import Scrollbar from "react-smooth-scrollbar";
import HeaderDesktop from "../HeaderDesktop/HeaderDesktop";
import classNames from "classnames";
import { Scrollbars } from "rc-scrollbars";

class Body extends React.Component<any, any> {
  constructor(props) {
    super(props);
  }

  render() {
    const { children, title, subtitle, step, bottomContent } = this.props;
    return (
      <>
        {window.screen.availWidth >= 768 ? (
          <>
            {/*<Scrollbar*/}
            {/*    alwaysShowTracks={true}*/}
            {/*    className={classNames({*/}
            {/*        [styles.body]: true,*/}
            {/*        [styles.fullHeight]: !bottomContent*/}
            {/*    })}*/}
            {/*    id="contentBoxBody"*/}
            {/*>*/}
            <Scrollbars
              renderTrackVertical={(props) => (
                <div {...props} className="track-vertical" />
              )}
              renderThumbVertical={(props) => (
                <div {...props} className="thumb-vertical" />
              )}
              renderTrackHorizontal={() => <div />}
              className={classNames({
                [styles.body]: true,
                [styles.fullHeight]: !bottomContent,
              })}
              id="contentBoxBody"
            >
              <div id="cbAnchor"></div>
              <HeaderDesktop
                title={title}
                type={this.props.type}
                subtitle={subtitle}
                step={step}
                maxStep={this.props.maxStep}
                setBoxContent={this.props.setBoxContent}
                boxContentLawyerInfo={this.props.boxContentLawyerInfo}
                imageUrl={this.props.imageUrl}
              />
              {children}
            </Scrollbars>
          </>
        ) : (
          <div
            className={classNames({
              [styles.body]: true,
              [styles.fullHeight]: !bottomContent,
            })}
            id="contentBoxBody"
          >
            <div id="cbAnchor"></div>
            {/*<HeaderDesktop*/}
            {/*    title={title}*/}
            {/*    subtitle={subtitle}*/}
            {/*    step={step}*/}
            {/*    maxStep={this.props.maxStep}*/}
            {/*    setBoxContent={this.props.setBoxContent}*/}
            {/*    boxContentLawyerInfo={this.props.boxContentLawyerInfo}*/}
            {/*    imageUrl={this.props.imageUrl}*/}
            {/*/>*/}
            {children &&
              React.cloneElement(children, { imageUrl: this.props.imageUrl })}
          </div>
        )}
        {bottomContent && (
          <div className={styles.bottomContent} id="bottomContent">
            {bottomContent}
          </div>
        )}
      </>
    );
  }
}

export default Body;
